import { defineComponent, ref, reactive, onMounted, toRefs, getCurrentInstance, onUnmounted } from 'vue';
import apis from "@/api";
export default {
  name: "TransLogTables",
  components: {},
  props: {
    columns: [],
    actionType: {
      type: String
    },
    startBtn: {
      type: String
    },
    cancelBtn: {
      type: String
    },
    uploadBtn: {
      type: String
    }
  },
  setup(props, context) {
    const {
      proxy
    } = getCurrentInstance();
    context = proxy;
    const data = reactive({
      tableData: [],
      multipleSelection: [],
      queryParam: {
        demandName: ''
      },
      columns: props.columns,
      startBtn: '暂停',
      cancelBtn: props.cancelBtn,
      actionType: props.actionType,
      uploadBtn: props.uploadBtn,
      multiSelection: [],
      previewShow: false,
      imgUrl: ''
    });
    const handleSelectionChange = val => {
      console.log("val", val);
      data.multiSelection = val;
    };
    const submitForm = () => {
      loadData();
    };
    const handleStart = (status, index) => {
      if (data.actionType == '1') {
        if (status == '0') {
          data.tableData[index].status = '3';
        }
        if (status == '3') {
          data.tableData[index].status = '0';
        }
      }
      if (data.actionType == '2') {
        if (status == '1') {
          data.tableData[index].status = '3';
        }
        if (status == '3') {
          data.tableData[index].status = '1';
        }
      }
    };
    const handleCancel = (row, index) => {
      console.log(" index!", index);
      data.tableData.splice(index, 1);
    };
    const matchState = (status, actionType) => {
      switch (actionType) {
        case '1':
          if (status == '0' && actionType == '1') {
            return true;
          }
        case '2':
          if (status == '1' && actionType == '2') {
            return true;
          }
        case '3':
      }
    };
    const formatterStatus = (row, index) => {
      if (row.status == '0' && data.actionType == '1') {
        return '正在上传';
      }
      if (row.status == '1' && data.actionType == '2') {
        return '正在下载';
      }
      if (row.status == '3' && data.actionType == '1') {
        return '已暂停';
      }
      if (row.status == '3' && data.actionType == '2') {
        return '已暂停';
      }
      if (row.status == '0' && data.actionType == '3') {
        return '上传完成';
      }
      if (row.status == '1' && data.actionType == '3') {
        return '下载完成';
      }
    };
    const stopAll = () => {
      for (let i = 0; i < data.multiSelection.length; i++) {
        for (let j = 0; j < data.tableData.length; j++) {
          if (data.multiSelection[i].id == data.tableData[j].id) {
            handleStart(data.tableData[j].status, j);
          }
        }
      }
    };
    const cancelAll = () => {
      console.log("cancelAll-->data:");
      for (let i = 0; i < data.multiSelection.length; i++) {
        for (let j = 0; j < data.tableData.length; j++) {
          if (data.multiSelection[i].id == data.tableData[j].id) {
            handleCancel(data.multiSelection, j);
          }
        }
      }
    };
    const deleteAll = () => {};
    // const openFile=()=>{
    //   apis.fileOpen();
    // };
    const loadData = () => {
      const params = {
        "operateType": '',
        "demandName": data.queryParam.demandName,
        "isUploading": '',
        "isDownloading": ''
      };
      switch (data.actionType) {
        //查询正在上传
        case "1":
          params.operateType = '0';
          params.isUploading = '0';
          apis.getUploading(params).then(res => {
            console.log("isUploading:records->", res);
            data.tableData = res.data;
          });
          break;
        //查询正在下载
        case "2":
          params.operateType = '1';
          params.isDownloading = '0';
          apis.getDownloading(params).then(res => {
            console.log("isDownloading:records->", res);
            data.tableData = res.data;
          });
          break;
        //查询上传完成,下载完成
        case "3":
          params.isDownloading = '1';
          params.isUploading = '1';
          apis.getAllLog(params).then(res => {
            console.log("All:records->", res);
            data.tableData = res.data;
          });
          break;
      }
    };
    const showPreviewDialog = srcInnUrl => {
      data.previewShow = true;
      data.imgUrl = srcInnUrl;
    };
    onMounted(() => {
      loadData();
      proxy.timer = setInterval(() => {
        loadData();
      }, 300000);
    });
    onUnmounted(() => {
      clearInterval(proxy.timer);
    });
    return {
      ...toRefs(data),
      proxy,
      handleSelectionChange,
      submitForm,
      handleStart,
      handleCancel,
      loadData,
      matchState,
      formatterStatus,
      stopAll,
      cancelAll,
      showPreviewDialog,
      deleteAll
    };
  }
};